export default __webpack_public_path__ + "assets/audio/1-50471616_clip.mp3";